import { JSONSchema7 } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, controlState: ControlState) => {
  state.pages.forEach((page: PageState) => {
    if (page.id === controlState.pageId) {
      const pageSchema = page.schema as JSONSchema7;
      const pageProperties = pageSchema.properties as JSONSchema7Properties;

      pageProperties[controlState.id] = controlState.schema as JSONSchema7;
      page.controls.forEach((control: ControlState) => {
        if (control.id === controlState.id) {
          control.schema = controlState.schema;
          return;
        }
      });
      return;
    }
  });
  return { ...state };
};
